import { useEffect, useState } from 'react';

import {isEmptyObj} from 'ultra/helpers/utils';
import TextField from '@mui/material/TextField';

import Button from '@mui/material/Button';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';

import CurrencyFormated from '../../CurrencyFormated'
import {useNotifyStore} from '../../../Stores/notify';

import Filter from '../Filter';

import './index.scss'

export default function PartnerPayments(props) {
    const {content, field, disabled, isEditMode, onChange, onBlur} = props;

    // const {formVisibleErrors} = useFormStore();
    // const showErrorText = formVisibleErrors[field.id];

    const {config} = field;

    const [price, setPrice] = useState(0);
    const [discount, setDiscount] = useState(0);

    const [filter, setFilter] = useState({});
    const [activePayment, setActivePayment] = useState();

    useEffect(() => {
        if (config) {
            let copied = {}
            config.map(i => {
                copied[i.id] = false
            })

            const f = {
                id: field.id,
                required: field.required,
                placeholder: field.placeholder,
                values: {
                    values: {},
                    order: [],
                },
                options: {
                    hasNoEmptyValue: true
                }
            }

            config.map(item => {
                f.values.values[item.id] = item.label;
                f.values.order.push(item.id);
            })

            setFilter(f)
        }
    }, [config])

    useEffect(() => {
        const ap = config?.find(i => i.id === content[field.id]);
        setActivePayment(ap);
        const p = parseInt(content[field.options?.priceAmountField]) * getDiscount(content?.promocode, ap?.price);
        setPrice(p);
        const d = parseInt(content[field.options?.priceAmountField]) * getDiscountValue(content?.promocode, ap?.price);
        setDiscount(d);
    }, [content[field.id]])

    useEffect(() => {
        const ap = config?.find(i => i.id === content[field.id]);
        const p = parseInt(content[field.options?.priceAmountField]) * getDiscount(content?.promocode, ap?.price);
        setPrice(p);
        const d = parseInt(content[field.options?.priceAmountField]) * getDiscountValue(content?.promocode, ap?.price);
        setDiscount(d);
    }, [content?.promocode, content?.guests])

    const amount = parseInt(content[field.options?.priceAmountField])

    const onChangeHandler = (e) => {
        const ap = config?.find(i => i.id === e.target.value);
        setActivePayment(ap);
        onChange(e);
        const p = parseInt(content[field.options?.priceAmountField]) * getDiscount(content?.promocode, activePayment?.price);
        setPrice(p);
        const d = parseInt(content[field.options?.priceAmountField]) * getDiscountValue(content?.promocode, activePayment?.price);
        setDiscount(d);
    }

    // TODO: OPTIMIZE
    const getDiscountValue = (code = "", price = 0) => {
        let result = 0

        if (field?.options?.discounts?.[code]) {
            switch(field.options.discounts[code].type) {
                case "percent":
                    result = (price * field.options.discounts[code].value / 100);
                    console.log(result)
                    break;
                case "value":
                    if (field.options.discounts[code].value?.[activePayment.id])
                        result = field.options.discounts[code].value[activePayment.id];
                    break;
                case "fixed":
                    if (field.options.discounts[code].value?.[activePayment.id])
                        result = price - field.options.discounts[code].value[activePayment.id];
                    break;
            }
        }

        return result
    }

    const getDiscount = (code = "", price = 0) => {
        let result = price
        return result - getDiscountValue(code, price);
    }

    const onBlurHandler = (e) => {
        onBlur(e);
    }

    if (!config || isEmptyObj(filter)) return <>no payment config</>

    return <div className='PartnerPaymentsControl'>

        {/* INFO: це тимчасове рішення, можливо треба буде видалити. Для купівлі квитків на подію треба використовувати корзину */}
        {field.options?.pricePre && activePayment && <div className='PricePre'>
            {field.options?.pricePre} за {amount} {amount === 1 ? "особу" : amount < 5 ? "особи" : "осіб"} {field.options?.priceSufix}
            &nbsp;
            <CurrencyFormated value={price} currency={activePayment.currency} />
            {discount > 0 && <div className='discount'>
                Знижка по промокоду <code>{content.promocode}</code> -<CurrencyFormated value={discount} currency={activePayment.currency} />
            </div>}
            {(field.options?.priceNotes1 || field.options?.priceNotes2) && <div className='notes'>
                {field.options?.priceNotes1 && <p>{field.options?.priceNotes1}</p>}
                {field.options?.priceNotes2 && <p>{field.options?.priceNotes2}</p>}
            </div>}
        </div>}

        {config.length > 1 && <div className='PaymentSelector'>
            <Filter
                {...props}
                onChange={onChangeHandler}
                onBlur={onBlurHandler}
                field={filter}
            />
        </div>}

        {config?.length === 1 && <div className='PaymentOptions'><PaymentOption payment={config[0]} /></div>}

        {config?.length > 1 && activePayment && <div className='PaymentOptions'><PaymentOption payment={activePayment} /></div>}
        
        {field?.notes &&  <div className='fieldNotes'>
            <p>{field.notes}</p>
        </div>}
    </div>
}

function PaymentOption(props) {
    const {payment} = props;

    const {showNotify} = useNotifyStore();

    const onCopyClick = (text) => {
        navigator.clipboard.writeText(text);
        showNotify({text: "Номер картки успішно скопійовано"});
    }

    return <>
        {payment.link && <Button variant="outlined" fullWidth href={payment.link} target="_blank">{payment.linkLabel || payment.label}</Button>}
        {payment.value && <div className='PaymentOption'>
            {/* <div className='labelWrap'>
                <span className='label'>{payment.label}:</span>
                <span className='labelValue'>{payment.value}</span>
            </div> */}
            <div>{payment.value}</div>
            {/* {!isMobile && <span className='Copy' onClick={() => onCopyClick(payment.value)}>
                <ContentCopyOutlinedIcon />
                <span>Скопіювати реквізити</span>
            </span>} */}
        </div>}
        {/* isMobile &&  */}
        {payment.value && <Button startIcon={<ContentCopyOutlinedIcon />} variant="outlined" fullWidth onClick={() => onCopyClick(payment.value)}>
            Скопіювати реквізити
        </Button>}
    </>
}